import React, { useEffect, useState } from "react";
import axios from "axios";
import he from "he";
import simple from "../../assets/simplewrk.png";
import { Link } from "react-router-dom";
// import workingout from "../../assets/yogawom.png";
import nodata from "../../assets/nodatafound.jpg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

function YogaMonth6({ selectedTool, setSelectedTool }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);

  const decodeHtmlEntities = (text) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    return doc.documentElement.textContent;
  };

  const handleClick = (item) => {
    setSelectedItem(item);
  };

  const closeOverlay = () => {
    setSelectedItem(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://skyraanapps.com/workouts/api_v1/app/item_list_by_cat_id",
          {
            category_id: 35,
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data && response.data.data) {
          setItems(response.data.data);
        } else {
          console.error("Invalid response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <div className="yoga-base">
        <div className="yoga-main">
          <div className="bread-container">
            <nav aria-label="breadcrumb">
              <ol className="crumb">
                <li className="breadcrumblist">
                  <Link
                    to="/"
                    className="breadcrumb-link"
                    onClick={() => setSelectedTool("")}
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumblist">
                  <Link to="/pregnancy-yoga" className="breadcrumb-link">
                    Yoga
                  </Link>
                </li>
                <li className="breadcrumblist active">6th month yoga</li>
              </ol>
            </nav>
          </div>
          <div id="main-yoga-dis">
            <div className="yoga-image">
              <img src={simple} alt="yoga-woman" />
            </div>
            <div className="yoga-cont">
              <h2 className="yoga-heading">Yoga for Moms</h2>
              <h4 className="yoga-subheading">Sixth Month Yoga</h4>
            </div>
          </div>
        </div>
        <div className="wrk-mainTwo">
          {loading ? (
            <div style={{ width: "250px" }}>
              <DotLottieReact
                src="https://lottie.host/86e46d4b-1429-4d0d-be88-b80e1a2f41a9/xBCBpFwQkP.lottie"
                loop
                autoplay
              />
            </div>
          ) : items.length > 0 ? (
            <div className="items-container">
              {items.map((item, index) => (
                <div
                  className="item-card"
                  key={index}
                  onClick={() => handleClick(item)}
                >
                  <img
                    src={item.item_img_url}
                    alt={decodeHtmlEntities(item.item_name)}
                  />
                  <h3>{decodeHtmlEntities(item.item_name)}</h3>
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="ndf-container">
                <img src={nodata} alt="No-Data-Found" id="no-data-found" />
                <h4 style={{ marginTop: "20px" }}>No Products Found</h4>
              </div>
            </>
          )}
        </div>
      </div>
      {selectedItem && (
        <div className="overlayy" onClick={closeOverlay}>
          <div
            className="overlay-contentt"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btnn" onClick={closeOverlay}>
              X
            </button>
            <figure>
              <img
                src={selectedItem.item_img_url}
                alt={decodeHtmlEntities(selectedItem.item_name)}
              />
              <figcaption>
                <h2 className="overlay-title" style={{ marginTop: "20px" }}>
                  {decodeHtmlEntities(selectedItem.item_name)}
                </h2>
                <p className="overlay-description">
                  {decodeHtmlEntities(selectedItem.item_description)}
                </p>
              </figcaption>
            </figure>
          </div>
        </div>
      )}
    </div>
  );
}

export default YogaMonth6;
